import { api } from "./users";

export const getTripLoadFactor = async (params = {}) => {
  const response = await api.get("/trips/load-factor/", { params });
  return response.data;
};
